export default __webpack_public_path__ + "static/media/bicycle_light.bbc70dc3.png";